import React from "react";
import {Button, FormControl, FormLabel, Grid, IconButton} from "@mui/material";
import {useTranslation} from "i18nano";
import DisplayTextComponent from "./DisplayTextComponent";
import TextFieldMemo from "./TextFieldMemo";
import {AppAnswer, AppQuestion} from "../types/types";
import {getAnswerCoords} from "./CommonComponent";
import {StatusUpdateAnswer} from "../types/UpdatePartyObject";
import DeleteIcon from '@mui/icons-material/Delete';

interface MultipleInputsComponentProps {
    item: AppQuestion;
    id: string;
    groupId?: number;
    groupOrder?: number;
    type?: "text" | "number";
    onInputChange: (value: string, item: AppQuestion, answerId: string, answerOrder: number, groupId?: number, groupOrder?: number, debounced?: boolean) => void,
    onAddNewTextField: (itemId: number, groupId?: number, groupOrder?: number,) => void;
    onClickRemoveTextField: (itemId: number, answerId: string, groupId?: number, groupOrder?: number) => void;
    onFocus: (event: React.FocusEvent<HTMLInputElement>, answerId: string, answerOrder: number, status?: StatusUpdateAnswer) => void;
    endAdornment?: (answerId: string) => React.JSX.Element;
}

const MultipleInputsComponent = ({
                                     item,
                                     id,
                                     groupId,
                                     groupOrder,
                                     type = "text",
                                     onInputChange,
                                     onAddNewTextField,
                                     onClickRemoveTextField,
                                     onFocus,
                                     endAdornment
                                 }: MultipleInputsComponentProps) => {
    const t = useTranslation();
    const hasError = item.answers.some(a => !!a.errorText);

    const renderAdornment = (answerId: string) => {
        if (!item.editable) return <></>;
        if (endAdornment) return endAdornment(answerId);
        return <IconButton
                tabIndex={-1}
                aria-label="delete text field"
                onClick={() => onClickRemoveTextField(item.id, answerId, groupId, groupOrder)}
                onMouseDown={e => e.preventDefault()}
                edge="end"
                disabled={!item.editable}
        >
            <DeleteIcon/>
        </IconButton>
    }

    const sortedAnswers = [...item.answers].sort((a, b) => a.order - b.order);
    return (
            <FormControl disabled={!item.editable} required={item.required} error={hasError}>
                <FormLabel required={false}>
                    <DisplayTextComponent text={item.displayText} required={item.required} hint={item.hint}/>
                </FormLabel>
                <Grid container spacing={1}>
                    {sortedAnswers.map((answer: AppAnswer) => {

                        const {answerId, answerOrder, status, errorText, text} = getAnswerCoords(answer);

                        return (<Grid item xs={12} key={`${id}-${answer.id}`}>
                                    <TextFieldMemo
                                            displayText={""}
                                            id={id}
                                            type={type}
                                            editable={item.editable}
                                            required={item.required}
                                            value={text}
                                            status={status}
                                            errorText={errorText}
                                            onChange={e => onInputChange(e.target.value, item, answerId, answerOrder, groupId, groupOrder, true)}
                                            endAdornment={renderAdornment(answerId)}
                                            onFocus={(e) => onFocus(e, answerId, answerOrder, status)}
                                    />
                                </Grid>
                        );
                    })}
                    {
                            item.editable && <Grid item xs={12} sm={2}>
                                <Button onClick={() => onAddNewTextField(item.id, groupId, groupOrder)}
                                        fullWidth
                                        variant="contained"
                                >
                                    {t("Add")}
                                </Button>
                            </Grid>
                    }
                </Grid>
            </FormControl>
    );
};

export default MultipleInputsComponent;